import MarkdownIt from "markdown-it";

const markdown = new MarkdownIt({
  breaks: true,
  html: false,
  linkify: true,
  typographer: false
});

const defaultLinkOpen =
  markdown.renderer.rules.link_open ??
  ((tokens, index, options, env, self) => self.renderToken(tokens, index, options));

markdown.validateLink = (url) => /^https?:\/\//i.test(String(url ?? "").trim());

markdown.renderer.rules.link_open = (tokens, index, options, env, self) => {
  const token = tokens[index];
  token.attrSet("target", "_blank");
  token.attrSet("rel", "noreferrer");
  return defaultLinkOpen(tokens, index, options, env, self);
};

export function renderMarkdown(text) {
  const source = String(text ?? "").replace(/\r\n?/g, "\n").trim();
  if (!source) {
    return "";
  }
  return markdown.render(source);
}
